
import { Options, Vue } from 'vue-class-component'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useStore } from '@/store'
import SelectOption from './verification/select-option/select-option.vue'
import Otp from './verification/otp/otp.vue'
import Dopa from './verification/dopa/dopa.vue'
import { StepEditMobile } from '@/model/step-edit-mobile.model'
import { Prop } from 'vue-property-decorator'
import NewMobile from './verification/new-mobile/new-mobile.vue'
import CustomerList from './verification/customer-list/customer-list.vue'
import CustomerProfiles from '@/interfaces/customer-profiles'

library.add(faChevronLeft)

@Options({
  components: {
    FontAwesomeIcon,
    SelectOption,
    Otp,
    Dopa,
    NewMobile,
    CustomerList,
  },
  computed: {
    isStep() {
      return this.$store.state.modalEditMobile.isStep
    },
    isModalClose() {
      return this.$store.state.modalEditMobile.isModalClose
    },
  },
})
export default class ModalEditMobilePage extends Vue {
  @Prop() customerProfileModel!: CustomerProfiles
  @Prop() getCustomerProfileFn!: (token: string) => void

  private store = useStore()
  private step = {
    otp: StepEditMobile.OTP_VERIFICATION,
    dopa: StepEditMobile.DOPA_VERIFICATION,
    newMobile: StepEditMobile.INPUT_NEW_MOBILE,
    customerList: StepEditMobile.SHOW_CUSTOMER_LIST,
  }

  closeModal() {
    const currentStep = this.store.state.modalEditMobile.isStep
    const currentLevel = this.store.state.modalEditMobile.level
    switch (currentStep) {
      case '':
        this.store.dispatch('modalEditMobile/onClose')
        break
      case StepEditMobile.OTP_VERIFICATION:
        if (currentLevel === 'L1') {
          this.store.dispatch('modalEditMobile/onResetStep')
        } else {
          this.store.commit('modalEditMobile/updateStep', StepEditMobile.INPUT_NEW_MOBILE)
        }
        break
      case StepEditMobile.INPUT_NEW_MOBILE:
        this.store.dispatch('modalEditMobile/onClose')
        break
      case StepEditMobile.SHOW_CUSTOMER_LIST:
        this.store.commit('modalEditMobile/updateStep', StepEditMobile.INPUT_NEW_MOBILE)
        break
      default:
        this.store.dispatch('modalEditMobile/onOpen')
        this.store.dispatch('modalEditMobile/onResetStep')
        break
    }
  }
}
